import { createRouter, createWebHistory } from 'vue-router';
import DomainChecker from '../components/DomainChecker.vue';
import DomainManager from '../components/DomainManager.vue';

const routes = [
  {
    path: '/',
    name: 'DomainChecker',
    component: DomainChecker
  },
  {
    path: '/manage',
    name: 'DomainManager',
    component: DomainManager
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
